import React from 'react';

/**
 * 카톡 아이콘 — 노란 네모 위 말풍선. 공지 탭 [카톡으로 다시 알리기]에서 쓰던 그림을 티어표 [카톡 공유]도 같이 쓴다
 * (사용자 2026-10-31 "카톡 공유 아이콘은 공지에 있는 걸 활용해").
 */
const KakaoIcon: React.FC<{ size?: number }> = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
    <rect x="0" y="0" width="24" height="24" rx="6" fill="#FEE500" />
    <path d="M12 5.2c-4.1 0-7.4 2.6-7.4 5.8 0 2.1 1.4 3.9 3.5 4.9l-.8 2.9c-.1.3.2.5.4.3l3.4-2.3c.3 0 .6.1.9.1 4.1 0 7.4-2.6 7.4-5.8S16.1 5.2 12 5.2Z" fill="#3A1D1D" />
  </svg>
);

export default KakaoIcon;
